import { lazy } from 'react';

export default [
  {
    title: 'counselling appointment',
    component: lazy(() => import('./book_counselling_appointment')),
    url: '/vas/counselling/:id/:shareId',
    requirePermission: true,
    roles: ['Client'],
  },
];
